<template>
  <div>
    <el-alert
      title="入库后托盘变为占用。该托盘库存出清后改回空闲。禁用托盘不会被库存改状态，也可以在这里手工调整。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.palletCode" clearable placeholder="托盘编码" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.palletName" clearable placeholder="名称" style="width:140px" @keyup.enter.native="search" />
      <el-select v-model="query.palletState" clearable placeholder="状态" style="width:120px">
        <el-option label="空闲" value="00" />
        <el-option label="占用" value="01" />
        <el-option label="禁用" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="palletCode" label="托盘编码" width="140" />
      <el-table-column prop="palletName" label="名称" min-width="140" />
      <el-table-column prop="wareHouseName" label="所属仓库" width="160" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.palletState === '00' ? 'success' : (row.palletState === '01' ? 'warning' : 'info')">
            {{ stateName(row.palletState) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.palletId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.palletId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.palletId ? '修改托盘' : '新增托盘'" :visible.sync="visible" width="520px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px">
        <el-form-item label="托盘编码"><el-input v-model="form.palletCode" /></el-form-item>
        <el-form-item label="托盘名称"><el-input v-model="form.palletName" /></el-form-item>
        <el-form-item label="所属仓库">
          <el-select v-model="form.wareHouseId" filterable clearable style="width:100%">
            <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.palletState" style="width:100%">
            <el-option label="空闲" value="00" />
            <el-option label="占用" value="01" />
            <el-option label="禁用" value="02" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listPallet, getPallet, savePallet, updatePallet, deletePallet } from '../../api/pallet'
import { selectEnabledWareHouse } from '../../api/warehouse'

function emptyForm() {
  return { palletId: '', palletCode: '', palletName: '', wareHouseId: '', palletState: '00', remark: '' }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { palletCode: '', palletName: '', palletState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false,
      form: emptyForm(), warehouses: []
    }
  },
  created() {
    this.load()
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
  },
  methods: {
    stateName(state) {
      if (state === '00') return '空闲'
      if (state === '01') return '占用'
      if (state === '02') return '禁用'
      return state || ''
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listPallet({
        currentPage: this.page, pageSize: this.pageSize,
        palletCode: this.query.palletCode, palletName: this.query.palletName, palletState: this.query.palletState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      getPallet(id).then(res => {
        const d = res.data || {}
        this.form = {
          palletId: d.palletId, palletCode: d.palletCode, palletName: d.palletName || '',
          wareHouseId: d.wareHouseId || '', palletState: d.palletState || '00', remark: d.remark || ''
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.palletCode) { this.$message.warning('请填写托盘编码'); return }
      this.saving = true
      const payload = Object.assign({}, this.form, {
        wareHouseId: this.form.wareHouseId || null,
        palletName: this.form.palletName || null,
        remark: this.form.remark || null
      })
      const req = this.form.palletId ? updatePallet(payload) : savePallet(payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deletePallet([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
